import { useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useComposerMenu } from "./useComposerMenu.js";

export function RetrievalSelector({
  retrievalMode,
  setRetrievalMode
}: {
  retrievalMode: string;
  setRetrievalMode: (mode: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const menu = useComposerMenu({ open, setOpen, triggerRef, menuRef });
  const select = (mode: string) => {
    setRetrievalMode(mode);
    menu.closeMenu();
  };

  return (
    <div className="retrieval-selector">
      <button
        ref={triggerRef}
        className="model-select-button"
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-controls="retrieval-mode-menu"
        onClick={() => open ? menu.closeMenu() : menu.openMenu()}
        onKeyDown={menu.onTriggerKeyDown}
      >
        <span>{retrievalMode}</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <div
          ref={menuRef}
          id="retrieval-mode-menu"
          className="model-menu"
          role="listbox"
          aria-label="检索模式"
          onKeyDown={menu.onMenuKeyDown}
        >
          <button type="button" role="option" aria-selected={retrievalMode === "摘要级检索"} onClick={() => select("摘要级检索")}>摘要级检索</button>
          <button type="button" role="option" aria-selected={retrievalMode === "全文级检索"} onClick={() => select("全文级检索")}>全文级检索</button>
        </div>
      )}
    </div>
  );
}
